export enum ServicingStatus {
  Released = 'Released',
  Retained = 'Retained',
  Both = 'Both'
}
